const EmbeddedRoles = Object.freeze({
  HOST: 'HOST',
  SPEAKER: 'SPEAKER',
  MODERATOR: 'MODERATOR',
  ATTENDEE: 'ATTENDEE',
  ACTIVE_ATTENDEE: 'activeAttendee'
});

export default EmbeddedRoles;
